"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.taskTypes = exports.taskStatus = exports.onboardingTask = void 0;
var onboardingTask = {
  USER_DETAILS: 'user_details',
  ADMINISTRATIVE_DETAILS: 'administrative_details',
  HOME_ADDRESS: 'home_address',
  EMERGENCY_CONTACT: 'emergency_contact',
  PAYMENT_DETAILS: 'payment_details',
  ADDITIONAL_DOCUMENTS: 'additional_documents',
  REVIEW_COMPENSATION: 'review_compensation',
  VERIFY_IDENTITY: 'identity_verification'
};
exports.onboardingTask = onboardingTask;
var taskStatus = {
  CREATED: 'created',
  COMPLETED: 'completed',
  // just on the UI
  FAILED: 'failed',
  INCOMPLETE: 'incomplete'
};
/**
 * Separation between kind of tasks.
 * It is set on the tasks Context, based on the page URL
 */

exports.taskStatus = taskStatus;
var taskTypes = {
  ONBOARDING: 'onboarding',
  PENDING_TASK: 'pendingTask'
};
exports.taskTypes = taskTypes;